import { useAddToBookmarks } from './useAddToBookmarks';
import { useAlerts } from './useAlerts';
import { useGlobalStyles } from './useGlobalStyles';
import { useSubscribeToCsatSurveys } from './useSubscribeToCsatSurveys';
import { useSubscribeToShowDemoExitConfirmation } from './useSubscribeToShowDemoExitConfirmation';
export const useNavigationCapabilities = () => {
  useAddToBookmarks();
  useGlobalStyles();
  useSubscribeToCsatSurveys();
  useAlerts();
  useSubscribeToShowDemoExitConfirmation();
};